/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { IChallengeClip } from '../challenge-clip-schema';
import { challengeClipSchema } from '../challenge-clip-schema';

export const updateClipCropStatusResponseSchema = createApiResponseSchema(
  challengeClipSchema,
) as z.ZodSchema<IAPI<IChallengeClip>>;

export type IUpdateClipCropStatusResponse = IAPI<IChallengeClip>;
